import { useDispatch, } from 'react-redux';
import React, { useEffect } from 'react';
import { withRouter, Route } from 'react-router-dom';
import { useAuth } from 'oidc-react';
import {
    setCurrentUserData,
    setShowLoaderStatus,
    setCurrentuserLoggedInStatus
} from '../../redux-building-blocks/actions';
export const PrivateRouteForTranscriptHistory = ({ component: Component, ...rest }) => {
    const auth = useAuth();
    const dispatch = useDispatch();
    const [state, setState] = React.useState({
        isLoading: true,
        user: null
    })

    useEffect(() => {
        let isCancelled = false;
        async function getUser() {
            try {
                // Check for OIDC error parameters in URL (not 'code' which is valid)
                const urlParams = new URLSearchParams(window.location.search);
                const error = urlParams.get('error');
                
                // Only redirect on actual OIDC errors, not on missing parameters
                if (error) {
                    console.error('OIDC redirect error:', error);
                    localStorage.clear();
                    await auth.userManager?.removeUser();
                    window.location.href = `${process.env.PUBLIC_URL}/`;
                    return;
                }
                
                let userdata = await auth.userManager?.getUser();
                
                // Only redirect if user data exists AND is expired
                // Don't redirect if userdata is null (still loading)
                if (userdata && userdata.expired) {
                    console.log('User token expired');
                    localStorage.clear();
                    await auth.userManager?.removeUser();
                    window.location.href = `${process.env.PUBLIC_URL}/`;
                    return;
                }
                
                if(!isCancelled){
                    dispatch(setCurrentUserData(userdata));
                    dispatch(setCurrentuserLoggedInStatus(true));
                    setState({ isLoading: false, user: userdata });
                }
            } catch (error) {
                console.error('Error getting user data:', error);
                if(!isCancelled){
                    localStorage.clear();
                    window.location.href = `${process.env.PUBLIC_URL}/`;
                }
            }
        }
        getUser();
        return () => {isCancelled = true; };

    }, [auth, dispatch]);


    useEffect(() => {
        dispatch(setShowLoaderStatus(state.isLoading));
    }, [state.isLoading, dispatch]);


    if (state.isLoading) {
        return (<></>)
    }

    return (

        <Route {...rest} render={(props) => (
            <Component {...props} user={state.user} />
        )} />
    )
}

export default withRouter(PrivateRouteForTranscriptHistory);